import { render, staticRenderFns } from "./verdatos.vue?vue&type=template&id=bf8cff7c&scoped=true"
import script from "./verdatos.vue?vue&type=script&lang=js"
export * from "./verdatos.vue?vue&type=script&lang=js"
import style0 from "./verdatos.vue?vue&type=style&index=0&id=bf8cff7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8cff7c",
  null
  
)

export default component.exports